import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    title: String,
    label: String,
    xtitle: String,
    ytitle: String,
    data: Array,
    xmin: { type: Number, default: 0 },
    xmax: { type: Number, default: undefined },
    ymin: { type: Number, default: 0 },
    ymax: { type: Number, default: undefined },
    xplotlines: Array,
    yplotlines: Array,
    xplotbands: Array,
    yplotbands: Array
  }

  connect() {
    Highcharts.chart(this.element.id, {
      chart: {
        type: 'line',
      },
      credits: false,
      title: {
        text: this.titleValue,
      },
      xAxis: {
        title: {
          text: this.xtitleValue,
        },
        min: this.xminValue,
        max: this.xmaxValue || this.dataValue[this.dataValue.length - 1][0],
        plotLines: this.xplotlinesValue,
        plotBands: this.xplotbandsValue,
      },
      yAxis: {
        title: {
          text: this.ytitleValue,
        },
        min: this.yminValue,
        max: this.ymaxValue || this.dataValue[this.dataValue.length - 1][1],
        plotLines: this.yplotlinesValue,
        plotBands: this.yplotbandsValue,
      },
      tooltip: {
        shared: true,
      },
      legend: {
        enabled: false,
      },
      series: [
        {
          name: this.labelValue,
          data: this.dataValue.map(([x, y]) => [Number(x), Number(y)]),
        },
      ],
    })
  }
}
